<template>
  <div class="setting-detail-product">
    <div class="basic-info-section">
      <el-row :gutter="16">
        <custom-data
          :span-column="6"
          label="Código"
          :data="elementoTipo.Codigo || 'N/A'"
        />
        <custom-data
          :span-column="6"
          label="Descripción"
          :data="elementoTipo.Descripcion || 'N/A'"
        />
        <custom-data
          :span-column="6"
          label="Elemento Base"
          :data="elementoTipo.ElementoBase?.Descripcion || 'N/A'"
        />
        <custom-data
          :span-column="6"
          label="Estado"
          :data="elementoTipo.Activo ? 'Activo' : 'Inactivo'"
        />
      </el-row>
    </div>

    <!-- Procesos configurados -->
    <div class="processes-section">
      <div class="section-header">
        <h3>Procesos Configurados</h3>
        <el-tag
          type="info"
          size="large"
        >
          Total: {{ procesoCount }} proceso{{ procesoCount !== 1 ? 's' : '' }}
        </el-tag>
      </div>

      <div
        v-if="!tieneProcesosPorDefecto"
        class="no-processes"
      >
        <el-empty description="No hay procesos configurados para este producto personalizado" />
      </div>

      <!-- Grilla de procesos -->
      <el-table
        v-else
        :data="elementoTipo.ProcesoElementoTipo || []"
        :style="{ width: '100%' }"
        border
        empty-text="Sin procesos configurados"
      >
        <el-table-column
          prop="Proceso.Descripcion"
          label="Proceso"
          min-width="150"
        />
        <el-table-column
          prop="Secciones.Descripcion"
          label="Sección"
          min-width="120"
        />
        <el-table-column
          prop="Recurso.Descripcion"
          label="Recurso"
          min-width="150"
        />
        <el-table-column
          label="Items"
          min-width="200"
        >
          <template #default="scope">
            <span
              v-if="!scope.row.Materiales || scope.row.Materiales.length === 0"
              class="text-muted"
            >
              Sin items
            </span>
            <span v-else-if="scope.row.Materiales.length === 1"> 1 item </span>
            <span v-else> {{ scope.row.Materiales.length }} items </span>
          </template>
        </el-table-column>
        <el-table-column
          label="Por Defecto"
          width="100"
          align="center"
        >
          <template #default="scope">
            <el-tag
              :type="scope.row.PorDefecto ? 'success' : 'info'"
              size="small"
            >
              {{ scope.row.PorDefecto ? 'Sí' : 'No' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Botones de acción -->
    <div class="action-buttons">
      <el-button @click="cerrar">Cerrar</el-button>
      <el-button
        type="primary"
        @click="editar"
        >Editar</el-button
      >
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import CustomData from '@/shared/components/custom_data.vue';

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:modelValue', 'close', 'edit']);

// Computed properties
const elementoTipo = computed(() => props.modelValue || {});

const tieneProcesosPorDefecto = computed(() => {
  return (
    elementoTipo.value.ProcesoElementoTipo && elementoTipo.value.ProcesoElementoTipo.length > 0
  );
});

const procesoCount = computed(() => {
  return elementoTipo.value.ProcesoElementoTipo?.length || 0;
});

// Métodos
const cerrar = () => {
  emit('close');
};

const editar = () => {
  emit('edit');
};
</script>

<style scoped>
.setting-detail-product {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.basic-info-section {
  margin-bottom: 30px;
  padding: 15px 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.processes-section {
  margin-bottom: 30px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0;
  color: #303133;
  font-weight: 600;
}

.no-processes {
  text-align: center;
  padding: 40px 20px;
}

.text-muted {
  color: #909399;
  font-style: italic;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
  flex-shrink: 0;
  background-color: white;
  position: sticky;
  bottom: 0;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: -20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  z-index: 10;
}
</style>
